var Reminder = function() {

    var expiredTokenRefresh = function () {
        setTimeout(function(){
            location.reload();
        }, expireTime);
    };


    return {
        //main function to initiate the module
        init: function() {
            expiredTokenRefresh();
        }

    };

}();

jQuery(document).ready(function() {
    Reminder.init();
});


function refreshCaptcha(){
    $.ajax({
        url: "/refereshcapcha",
        type: 'get',
        dataType: 'html',
        success: function(json) {
            $(document).ready(function () {
                // $('#refresh_captcha').html(json);
                $('#refresh_captcha_p > img').replaceWith(json);
            });
        },
        error: function(data) {
            alert('Try Again.');
        }
    });
}

function save() {
    var first_name = $('input[name="first_name"]').val();
    var last_name = $('input[name="last_name"]').val();
    var mobile = $('input[name="mobile"]').val();
    var email = $('input[name="email"]').val();
    var insurance_type = $('select[name="insurance_type"]:selected').val();
    var insurance_endDate = $('input[name="insurance_endDate"]').val();
    var captcha = $('input[name="captcha"]').val();

    if(first_name == '' || last_name == '' || mobile == '' || captcha == '' || insurance_type == '' || insurance_endDate == '') {
        toastr.error('اطلاعات به درستی تکمیل نشده است');
        return false;
    }

    $.ajaxSetup({
        headers: {'CSRF-Token': $('meta[name="CSRFToken"]').attr('content')}
    });

    $.ajax({
        type: "POST",
        url: addNewUserUrl,
        data: {
            emailAddress: email,
            phoneNumber: mobile,
            first_name: first_name,
            last_name: last_name,
            captcha: captcha,
        },
        success: function (data) {
            if (!data.status) {
                refreshCaptcha();
                toastr.error(data.message);
                return false;
            }else {
                $('input[name="user_id"]').val(data.data);
                $('.reminder-form').submit();
            }
        }
    });
}

//////////////province and city//////////////
var ctfield = 'city_data';

var generateOption = function(value, text, data_value) {
    if(typeof data_value === 'undefined')
        data_value = '';
    else
        text += '-';
    var _html = '<option value="' + value + '" data-value="'+data_value+'">' + text + data_value + '</option>';
    return _html;
};

var generateMultipleOptions = function(data_arr, value_field, text_field, data_value_field) {
    var _html = '';
    for(var _i = 0; _i < data_arr.length; _i++) {
        _html += generateOption(data_arr[_i][value_field], data_arr[_i][text_field], data_arr[_i][data_value_field]);
    }
    return _html;
};

var initCityData = function() {
    if(window.hasOwnProperty(ctfield))
        return loadCitySelect(window[ctfield]);
    $.get({
        url: city_data_url,
        dataType: 'JSON',
        success: function(data) {
            window[ctfield] = data;
            return loadCitySelect(data);
        }
    });
};


var loadCitySelect = function(city_data) {
    var provinceSelector = '.province_select';
    var _html = generateMultipleOptions(city_data, 'id', 'province_name', '');
    _html = generateOption('NAN', 'استان') + _html;
    $('select[name="province"]').append(_html);
    generateProvinceChangeEvent();
};

var generateProvinceChangeEvent = function() {
    var _selector = '.province_select';
    $(_selector).change(function() {
        initCityByProvinceId(this.value);
    });
};

var initCityByProvinceId = function(ctid) {
    var _selector = '.city_select';
    var _city = getCityByProvinceId(ctid);
    var _html = generateMultipleOptions(_city, 'id', 'city_name_trans');
    $(_selector).empty();
    _html = generateOption('NAN', 'انتخاب کنید') + _html;
    $(_selector).append(_html);
};

var getCityByProvinceId = function(ctid) {
    var province_data = window[ctfield];
    var _city = [];
    $(province_data).each(function(index, cd){
        if(cd.id == parseInt(ctid)){
            _city = cd.cities;
        }
    });
    return _city;
};


var initAll = function() {

    if(typeof (city_data_url) !== 'undefined') {
        initCityData();
    }

};

initAll();